import $ from "jquery";
export function addProfessionalExperience(professionalExperience) {
	$.each(professionalExperience, (key, value) => {	
		$('#professionalExperience > .content').append(`
			<div class='professionalExperienceBox' id="pe${key}">
				<div class="date container peelem">
					<p class="petitle">Date: </p>
					<div class="pevalue">${value.date}</div>
				</div>
				<div class="company container peelem">
					<p class="petitle">Company: </p>
					<div class="pevalue">${value.company}</div>
				</div>
				<div class="position container peelem">
					<p class="petitle">Position:</p>
					<div class="pevalue">${value.position}</div>
				</div>
				<div class="generalResponsibilities container peelem">
					<p class="petitle">General Responsibilities: </p>
					<div class="pevalue">${value.generalResponsibilities}</div>
				</div>
				<div class="mainTechnologies container peelem">
					<p class="petitle">Main Technologies: </p>
					<div class="pevalue container">
						${value.mainTechnologies.map(value => `<p class="peskill">${value}<p>`).join('')}
					</div>
				</div>
			</div>
		`);
	});
}
